import React from "react";
import { Helmet } from "react-helmet";
import ContinueShopping from "../components/ContinueShopping";
//import GoBack from "../components/GoBack";

import "./About.css";
import useScrollToTopReact from "../hooks/useScrollToTopReact";

export default function WithdrawalRightScreen() {
  useScrollToTopReact();

  return (
    <>
      <Helmet>
        <title>beddo™ | Teslimat Ve İade Koşulları</title>
        <meta
          name="description"
          content="beddo™ ile alışveriş yaptınız ya da yapmayı mı düşünüyorsunuz? Teslimat ve iade koşullarımızı okuyun. beddo™ ile riskiniz SIFIR. Ya üründen memnun kalıyorsunuz ya da paranızı son kuruşuna kadar geri alıyorsunuz."
        />
        <meta
          name="keywords"
          content="beddo, beddo kim, beddo hakkında, beddo ekibi, beddo nedir, beddo ortopedik ürünler"
        />
        <meta name="author" content="beddo™ Marketing Team" />
        <meta name="application-name" content="beddo™ ERP" />
      </Helmet>
      <div className="about-shadow-platform">
        <div className="inline">
          <h2 className="fs15 beddo-border-bottom marupside1">
            Teslimat Ve İade Koşulları
          </h2>
          <br></br>
          <br></br>
        </div>
        <h1>beddo™ İade Koşulları</h1>
        <br></br>
        <br></br>
        <div className="about-content-div">
          <p>
            ALICI, sözleşme tarihinden itibaren 90 gün içinde malı redederek
            cayma hakkına sahiptir. İade ürünün beddo™'ya ulaşmasını takip eden
            5 iş günü içinde ürün bedeli ALICI'ya iade edilir.
          </p>
          <br></br>
          <br></br>
          <p>
            ALICI, iade başlatmak için www.beddo.com adresinde bulunan "Müşteri
            Hizmetleri" alanına giriş yapmalıdır. Alıcı sistemde kayıtlı cep
            telefonuna SMS ile gönderilen şifreyi kullanarak "Müşteri
            Hizmetleri" alanına güvenli giriş yapabilir.
          </p>
          <br></br>
          <br></br>
          <p>
            Herhangi bir nedenle müşteri hizmetleri sayfasına giriş yapmak
            mümkün olmaz ise ALICI, destek@beddo.com adresine e-posta göndererek
            beddo™'ya ulaşabilir.
          </p>
          <br></br>
          <br></br>
          <p>
            Cayma hakkı nedeni ile iade edilen ürünün kargo bedeli beddo™
            tarafından karşılanır.
          </p>

          <br></br>
          <br></br>
          <p>
            <span className="bold-font">Not:</span> 90 gün iade garantisi sadece{" "}
            <span className="bold-font">beddo.com</span> sitemizden yapacağınız
            alışverişlerde geçerlidir. Trendyol vb. pazaryeri sitelerinden ya da
            medikal mağazalardan aldığınız beddo™ ürünlerinde, pazaryeri
            sitesinin ve mağazanın iade koşulları geçerli olur.
          </p>
          <br></br>
          <br></br>
        </div>
        <h1>beddo™ Teslimat Koşulları</h1>
        <br></br>
        <br></br>
        <div className="about-content-div">
          <p>
            Tüm siparişler beddo.com ürün detay sayfasında belirtilen süreler
            içerisinde Yurt İçi Kargo'ya teslim edilir.
          </p>
          <br></br>
          <br></br>
          <p>
            Aksi belirtilmediği sürece tüm kargo ücretleri beddo™ tarafından
            ödenir.
          </p>
          <br></br>
          <br></br>
          <p>
            ALICI, beddo.com sipariş sayfasında ödeme yöntemini "Kart ile ödeme"
            ya da "Kapıda ödeme" olarak seçebilir.
          </p>
          <br></br>
          <br></br>
          <p>
            Kapıda ödeme limiti 900 TL'dir. ALICI, 900 TL'den daha yüksek
            tutarlı siparişlerini sadece kart ile ödeyebilir.
          </p>
          <br></br>
          <br></br>
          <p>
            ALICI, teslimat ile ilgili bir sorun yaşar ise yine beddo™ müşteri
            hizmetleri sayfasına giriş yaparak ya da destek@beddo.com adresine
            e-posta göndererek sorunu beddo™ ekibine iletebilir. beddo™ ekibi
            ALICININ sorununu çözmek için en üst seviyede çaba gösterir.
          </p>
          <br></br>
          <br></br>
          <p>
            beddo™, 90 gün iade garantisini suistimal ettiğine inandığı
            ALICILARDAN gelen yeni siparişleri reddetme hakkına sahiptir.
          </p>
          <br></br>
          <br></br>
        </div>
        <ContinueShopping />
      </div>
    </>
  );
}
